// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const MetaverseLg = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M12.0115 2L20.8228 7.08735V15.9563C20.8228 16.3532 20.7183 16.7431 20.5198 17.0868C20.3214 17.4305 20.036 17.7159 19.6922 17.9144L13.142 21.6971C12.7983 21.8955 12.4084 22 12.0115 22C11.6146 22 11.2247 21.8955 10.881 21.6971L4.33072 17.9144C3.987 17.7159 3.70158 17.4305 3.50313 17.0868C3.30468 16.7431 3.20021 16.3532 3.2002 15.9563V7.08735L12.0115 2Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.0114 6.52206V12.1747M12.0114 12.1747L7.11621 15.001M12.0114 12.1747L16.9065 15.001" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);
